import NotificationBanner from '../shared/NotificationBanner';

export default function NoProductsBanner({ onResolve }) {
  return (
    <NotificationBanner
      title="No products found"
      subtitle="Create one to get started"
      severity="warning"
      onResolve={onResolve}
      resolveText="Resolve"
    />
  );
}
